
import { defineComponent, ref } from 'vue';
import TelaPadraoCrud from '@/core/components/TelaPadraoCrud.vue';
import { useCrudBase } from '@/core/composables/CrudBase';
import FuncaoModal from '@/views/Cadastros/Pessoas/Colaboradores/FuncaoModal.vue';
import { ECustomRenderRow } from '@/core/models/AntDesign/IColumn';
import { IOrdenacao } from '@/core/models/Consulta/IOrdenacao';
import ServicoFuncaoColaborador from '@/servicos/Cadastros/Pessoas/ServicoFuncaoColaborador';
import { EPermissaoDados } from '@/models/Enumeradores/MeuSistema/Usuarios/EPermissaoDados';

export default defineComponent({
  name: 'FuncaoColaborador',
  components: {
    TelaPadraoCrud,
    FuncaoModal,
  },
  setup() {
    const {
      crudBase, preencherEstrutura, exibirModal, sincronizaTelaCrud,
    } = useCrudBase();
    const servicoFuncaoColaborador = new ServicoFuncaoColaborador();

    const refCrudFuncaoColaborador = ref<InstanceType<typeof TelaPadraoCrud>>();

    crudBase.estrutura = preencherEstrutura();
    crudBase.estrutura.apresentarEmpresas = true;
    crudBase.estrutura.verificarCadastroCompartilhado = true;
    crudBase.estrutura.botaoPrincipalAcao = 'Nova';
    crudBase.estrutura.mensagemExclusao = 'Você confirma a exclusão da função:';
    crudBase.estrutura.colunasGrade = [
      {
        title: 'Descrição', dataIndex: 'descricao', key: 'Descricao', position: 0, visible: true, ordering: true, fixed: 'left', align: 'left', customRenderRow: ECustomRenderRow.LinkAcao,
      },
      {
        title: 'Código', dataIndex: 'codigo', key: 'Codigo', position: 1, visible: false, ordering: true,
      },
      {
        title: 'Status', dataIndex: 'ativo', key: 'ativo', position: 2, visible: true, align: 'left', width: 100, customRenderRow: ECustomRenderRow.TagAtiva,
      },
      {
        title: 'Ações', key: 'acoes', position: 7, visible: true, fixed: 'right', width: 100, align: 'center', customRenderRow: ECustomRenderRow.IconeAcoes,
      },
    ];
    crudBase.estrutura.ordenacaoPadraoGrade.push({ identificador: 'Codigo', ordem: 'DESC' } as IOrdenacao);

    async function sincronizarRegistro(acao: EPermissaoDados, codigoRegistro: number) {
      if (refCrudFuncaoColaborador.value !== undefined) {
        await refCrudFuncaoColaborador.value.sincronizarRegistro(acao, codigoRegistro);
      }
    }
    return {
      crudBase,
      servicoFuncaoColaborador,
      refCrudFuncaoColaborador,
      exibirModal,
      sincronizaTelaCrud,
      sincronizarRegistro,
    };
  },
});
